import sysMsg from '@/helpers/system.message'
import baneadosServices from '@/services/baneados.services'

const state = {
    tipos: [],
    comparadores: []
}
const getters = {
    tipos: (state) => {
        return state.tipos
    },
    comparadores: (state) => {
        return state.comparadores
    }
}

const mutations = {
    setTipo(state, tipo) {
        state.tipos.push(tipo);
    },
    getTipos(state, tipos) {
        state.tipos = tipos
    },
    setComparador(state, comparador) {
        state.comparadores.push(comparador);
    },
    getComparadores(state, comparadores) {
        state.comparadores = comparadores
    }
}

const actions = {
    setTipo(context, payload) {
        baneadosServices.tipos.set(payload).then(response => {
            context.commit('setTipo', response.data);
            sysMsg.getMessage('Registro actualizado', 'success')
        }).catch(error => {
            sysMsg.getResponseMessage(error.response);
        });
    },
    getTipos({commit}) {
        baneadosServices.tipos.getAll().then(response => {
            commit('getTipos', response.data);
        }).catch(error => {
            sysMsg.getResponseMessage(error.response);
        });
    },
    
    /* Comparadores */
    setComparador(context, payload) {
        baneadosServices.comparadores.set(payload).then(response => {
            context.commit('setComparador', response.data);
            sysMsg.getMessage('Registro actualizado', 'success')
        }).catch(error => {
            sysMsg.getResponseMessage(error.response);
        });
    },
    getComparadores({commit}) {
        baneadosServices.comparadores.getAll().then(response => {
            commit('getComparadores', response.data);
        }).catch(error => {
            sysMsg.getResponseMessage(error.response);
        });
    }
}

export const baneados = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}